import { ChapterHeader, FadeUp } from "./Motion";
import { ExternalLink } from "lucide-react";
import { trackEvent } from "@/lib/api";

const COMPETITION_PHOTOS = [
    "https://customer-assets-jt897jd0.emergentagent.net/job_wrestling-young/artifacts/enu7s5ih_jai4.png",
    "https://customer-assets-jt897jd0.emergentagent.net/job_wrestling-young/artifacts/kppq089y_IMG_2039.png",
    "https://customer-assets-jt897jd0.emergentagent.net/job_wrestling-young/artifacts/imk8nlp2_IMG_2038.png",
];

export default function Results({ content }) {
    const profiles = (content.externalProfiles || []).filter((p) => p.url);
    return (
        <section id="results" className="relative py-20 md:py-32 border-t border-white/10">
            <div className="max-w-[1600px] mx-auto px-5 md:px-10">
                <ChapterHeader
                    num="07"
                    kicker="Verify & Follow"
                    title="Results & External Profiles"
                    testId="chapter-results"
                />

                <FadeUp>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-white/10 border border-white/10 mb-4">
                        {COMPETITION_PHOTOS.map((src, i) => (
                            <div key={i} className="aspect-[3/4] bg-black overflow-hidden">
                                <img
                                    src={src}
                                    alt={`Competition ${i + 1}`}
                                    className="w-full h-full object-cover"
                                    loading="lazy"
                                    data-testid={`comp-photo-${i}`}
                                />
                            </div>
                        ))}
                    </div>
                    <div className="chapter-num text-white/50 text-right mb-10">
                        Photos by <span className="text-brand-gold">Michael Pappas</span>
                    </div>
                </FadeUp>

                <FadeUp delay={0.1}>
                    <div className="chapter-num mb-3">External Profiles</div>
                    {profiles.length === 0 ? (
                        <div className="border border-white/10 p-6 font-mono text-sm text-white/50 uppercase tracking-[0.15em]">
                            External recruiting profile links will be listed here as they become available.
                        </div>
                    ) : (
                        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
                            {profiles.map((p) => (
                                <a
                                    key={p.platform}
                                    href={p.url}
                                    target="_blank"
                                    rel="noreferrer"
                                    onClick={() => trackEvent("external_click")}
                                    className="p-5 bg-black hover:bg-white/5 flex items-center justify-between group transition-colors"
                                    data-testid={`profile-${p.platform}`}
                                >
                                    <div>
                                        <div className="chapter-num">Verified</div>
                                        <div className="font-mono uppercase text-base md:text-lg mt-2 group-hover:text-brand-gold transition-colors">
                                            {p.platform}
                                        </div>
                                    </div>
                                    <ExternalLink size={16} className="text-white/40 group-hover:text-brand-gold" />
                                </a>
                            ))}
                        </div>
                    )}

                    <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10 border border-white/10">
                        {(content.accomplishments || []).map((a) => (
                            <div key={a.id} className="p-6 bg-black">
                                <div className="chapter-num">Accomplishment</div>
                                <div className="font-mono text-base md:text-lg mt-2">{a.title}</div>
                                {a.year && (
                                    <div className="chapter-num mt-1 text-brand-gold">{a.year}</div>
                                )}
                            </div>
                        ))}
                    </div>
                </FadeUp>
            </div>
        </section>
    );
}
